"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeQuickactions_en_us = void 0;
function backofficeQuickactions_en_us() {
    return {
        "backoffice.quickactions.notloggedin": "Please first login or create a new account and repeat your last action afterwards.",
        "backoffice.quickactions.unknown.title": "Unknown Action",
        "backoffice.quickactions.unknown.message": "This link seems to be broken. Please let our support know if this keeps on happening!",
        "backoffice.quickactions.book.title": "Book Subscription",
        "backoffice.quickactions.book.message": "You will be redirected to your project to proceed with the booking...",
        "backoffice.quickactions.book.noprojectfound": "No project found! Please create a project and proceed with the booking!",
        "backoffice.quickactions.redirect": "You will be redirected to the Cloud Dashboards in 5 seconds...",
        "backoffice.quickactions.optin.title": "Confirming Opt-In",
        "backoffice.quickactions.optin.loading": "Your request to optin is being progressed...",
        "backoffice.quickactions.optin.done": "You successfully subscribed to our list.",
        "backoffice.quickactions.optout.title": "Confirming Opt-Out",
        "backoffice.quickactions.optout.loading": "Your request to opt-out is being progressed...",
        "backoffice.quickactions.optout.done": "You successfully unsubscribed from our list."
    };
}
exports.backofficeQuickactions_en_us = backofficeQuickactions_en_us;
